import { pubPageAdTargeting } from "@config/AdsConstants";
import Advertisement from "@elements/Advertisement/Advertisement";
import { GoogleAdsSlotFactory } from "@elements/Advertisement/helpers";
import {
  AdTargetingType,
  AdvertisementTypeEnum,
  ArticleAdPageTargetingType,
  ArticleAdSlotTargetingType,
  PageAdTargetValue,
} from "@typings/Ads.d";
import { twMerge } from "tailwind-merge";

type AdsImuProps = {
  sectionName: string;
  rootClassName?: string;
  pageAdTargetType: PageAdTargetValue;
  articlePageTarget?: ArticleAdPageTargetingType[];
  articleSlotTarget?: ArticleAdSlotTargetingType[];
  gsChannels?: string[];
};

/**
 * Tabla IMU Ads
 * Description: The IMU ads to render required ads.
 * @sectionName - name of section or page
 * @rootClassName - to override the classes
 */

export function AdsImu1({
  sectionName,
  rootClassName,
  pageAdTargetType,
  articlePageTarget,
  articleSlotTarget,
  gsChannels,
}: AdsImuProps) {
  const PubPageAdTarget = pubPageAdTargeting[
    pageAdTargetType
  ] as AdTargetingType<PageAdTargetValue>;
  return (
    <Advertisement
      rootClassName={twMerge("mb-5 lg:min-h-60", rootClassName)}
      adUnitProps={{
        type: AdvertisementTypeEnum.IMU1,
        slot: GoogleAdsSlotFactory(AdvertisementTypeEnum.IMU1, sectionName),
        id: "dfp-ad-imu1",
        pubAdTargeting: [PubPageAdTarget],
        articlePageTarget,
        articleSlotTarget,
        gsChannels,
      }}
    />
  );
}

export function AdsImu2({
  sectionName,
  rootClassName,
  pageAdTargetType,
  articlePageTarget,
  articleSlotTarget,
  gsChannels,
}: AdsImuProps) {
  const PubPageAdTarget = pubPageAdTargeting[
    pageAdTargetType
  ] as AdTargetingType<PageAdTargetValue>;
  return (
    <Advertisement
      rootClassName={twMerge(rootClassName)}
      adUnitProps={{
        type: AdvertisementTypeEnum.IMU2,
        slot: GoogleAdsSlotFactory(AdvertisementTypeEnum.IMU2, sectionName),
        pubAdTargeting: [PubPageAdTarget],
        articlePageTarget,
        articleSlotTarget,
        gsChannels,
      }}
    />
  );
}

export function AdsMidArticle({
  sectionName,
  rootClassName,
  pageAdTargetType,
  articlePageTarget,
  articleSlotTarget,
  gsChannels,
}: AdsImuProps) {
  const PubPageAdTarget = pubPageAdTargeting[
    pageAdTargetType
  ] as AdTargetingType<PageAdTargetValue>;
  return (
    <Advertisement
      rootClassName={twMerge("block ", rootClassName)}
      adUnitProps={{
        type: AdvertisementTypeEnum.MIDARTICLESPECIAL,
        slot: GoogleAdsSlotFactory(
          AdvertisementTypeEnum.MIDARTICLESPECIAL,
          sectionName,
        ),
        pubAdTargeting: [PubPageAdTarget],
        articlePageTarget,
        articleSlotTarget,
        gsChannels,
      }}
    />
  );
}
